module.exports = __webpack_public_path__ + "img/ic_close.e0f80d4.svg";